import { render } from "./entites.vue?vue&type=template&id=308249ca"
import script from "./entites.vue?vue&type=script&lang=js"
export * from "./entites.vue?vue&type=script&lang=js"

import "./entites.vue?vue&type=style&index=0&id=308249ca&lang=css"

import exportComponent from "/home/app-corporate-consiliumplus/front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__